import React, { useState, useEffect } from 'react'
import Wizard from '../../common/Wizard'
import FamilySelectPage from './FamilySelectPage'
import { isSelectFamilyMember } from '../../../utils/familyUtils'
import {
  isNeedToAskEmergencyContactUpdate,
  isNeedToAskSex,
  isNeedToShowQueueAppointmentsPage,
} from '../../../utils/getCareUtils'
import { useDispatch, useSelector } from 'react-redux'
import {
  isPrimaryServiceSelected,
  isRescheduleFlow,
} from '../../../utils/clinicsUtils'
import Bot from '../Bot'
import SexSelectPage from './SexSelectPage/SexSelectPage'
import DeclareLocation from '../DeclareLocation'
import EmergencyContact from '../EmergencyContact'
import MyPharmacy from '../MyPharmacy'
import DoctorSelectPage from './DoctorSelectPage'
import {
  isNeedToAskMyPharmacyUpdate,
  isNeedToSkipScheduleAppointment,
  isNeedToAskDesignatedDoctor,
} from '../../../utils/appointmentsUtils'
import ScheduleSelectPage from './ScheduleSelectPage/ScheduleSelectPage'
import QueueAppointmentsPage from './QueueAppointmentsPage'
import IntentPage from './IntentPage'
import {
  getIsHmoMember,
  isNeedToAskForHmoPolicyConsent,
} from '../../../utils/hmoUtils'
import Actions from '../../../actions'

import './GetCare.css'

const pages = [
  {
    key: 'FamilySelect',
    component: FamilySelectPage,
    filter: state =>
      !isSelectFamilyMember(state) && !!state.account?.activeMembers?.length,
  },
  {
    key: 'SexSelect',
    component: SexSelectPage,
    filter: state => isNeedToAskSex(state),
  },
  {
    key: 'QueueAppointments',
    component: QueueAppointmentsPage,
    filter: state =>
      isNeedToShowQueueAppointmentsPage(state) && !isRescheduleFlow(state),
  },
  {
    key: 'IntentPage',
    component: IntentPage,
    filter: state =>
      !!getIsHmoMember(state?.profile?.userDetails) &&
      isPrimaryServiceSelected(state),
  },
  {
    key: 'MedicalBot',
    component: Bot,
    filter: state => !isRescheduleFlow(state),
  },
  {
    key: 'DeclareLocation',
    disableBack: true,
    component: DeclareLocation,
  },
  {
    key: 'EmergencyContact',
    component: EmergencyContact,
    displaySkip: true,
    filter: state => isNeedToAskEmergencyContactUpdate(state),
  },
  {
    key: 'MyPharmacy',
    component: MyPharmacy,
    displaySkip: true,
    filter: state => isNeedToAskMyPharmacyUpdate(state),
  },
  {
    key: 'DoctorSelect',
    component: DoctorSelectPage,
    filter: state => isNeedToAskDesignatedDoctor(state),
  },
  {
    key: 'ScheduleSelect',
    component: ScheduleSelectPage,
    filter: state => !isNeedToSkipScheduleAppointment(state),
  },
]

const pagesWithoutSchedule = ['MedicalBot']

export const GetCare = () => {
  const dispatch = useDispatch()

  const state = useSelector(state => state)
  const [pageComponents, setPageComponents] = useState([])
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const isFlowWithoutSchedule = useSelector(
    state => isNeedToSkipScheduleAppointment(state) && !isRescheduleFlow(state)
  )

  const selectedService = useSelector(state => state.getCare?.selectedService)

  useEffect(() => {
    // check consent if the user is hmo member only
    // should be checked every time the page is loaded
    const isAdminHMO = getIsHmoMember(state?.profile?.userDetails)
    if (isAdminHMO) {
      if (isNeedToAskForHmoPolicyConsent(state?.medicalInfo?.consents)) {
        dispatch(Actions.createAction(Actions.SHOW_HMO_PRIVACY_CONCENT_DIALOG))
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // In case of reminder flow we want to show only bot page because the appointment is already scheduled
    // In case of reminder flow we want to show only bot page because the appointment is already scheduled
    // flowwithoutSchedule flag indicates we are not is reschedule flow but we need to skip schedule (reminders, fu notification etc)
    const pagesAfterFilter = pages.filter(page =>
      isFlowWithoutSchedule
        ? pagesWithoutSchedule.includes(page.key)
        : page?.filter
        ? page.filter(state)
        : true
    )
    setPageComponents(pagesAfterFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages, selectedMemberId, selectedService])

  return (
    <div className="get-care-page">
      <Wizard pages={pageComponents} />
    </div>
  )
}

export default GetCare
